/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Reset_Label_ButtonInputs */



/**
* | output |
* | --- |
* | "Reset recording" |
*
* @param {Audio_Recorder_Reset_Label_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_reset_label_button = /** @type {((inputs?: Audio_Recorder_Reset_Label_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Reset_Label_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialiser l'enregistrement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufnahme zurücksetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimposta registrazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сбросить запись")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restablecer grabación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重置录制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("記録をリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्डिंग रीसेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reiniciar gravação")
	return /** @type {LocalizedString} */ ("Reset recording")
});